import { AnswerMap } from '../AnswerMap';

export class Condition {
  private values: AnswerMap;

  private orCondition: boolean;

  constructor(values: AnswerMap, orCondition: boolean) {
    this.values = values;
    this.orCondition = orCondition;
  }

  public evaluate(answers: AnswerMap): boolean {
    let match: boolean = false;

    const keys: string[] = Object.keys(this.values);
    for (let i = 0; i < keys.length; i++) {
      match = this.evaluateConditionAttribute(keys[i], answers);

      if ((match && this.orCondition) || (!match && !this.orCondition)) {
        break;
      }
    }

    return match;
  }

  private evaluateConditionAttribute(key: string, answers: AnswerMap): boolean {
    let match: boolean = false;
    const currentValue: string | string[] | boolean | null | undefined = answers[key];
    const matchValue: string | string[] | boolean | null | undefined = this.values[key];

    if (matchValue === null || (Array.isArray(matchValue) && matchValue.length === 0)) {
      match = typeof (currentValue) === 'undefined' || currentValue === null || (typeof currentValue !== 'boolean' && currentValue.length === 0);
    } else if (Array.isArray(matchValue)) {
      let comparisonArray: any[] = [];
      if (Array.isArray(currentValue)) {
        comparisonArray = [...currentValue];
      } else {
        comparisonArray.push(currentValue);
      }
      // Current value array must contain each item in the condition array/one value if "or" flag set
      for (let i = 0; i < matchValue.length; i++) {
        if (matchValue[i].startsWith('!')) {
          // Must contain a value which is NOT the string
          const notValue: string = matchValue[i].substring(1);

          for (let x = 0; x < comparisonArray.length; x++) {
            match = comparisonArray[x] !== notValue;
            if (match) {
              break;
            }
          }
        } else {
          match = currentValue !== null && currentValue !== undefined && comparisonArray.includes(matchValue[i]);
        }
        if ((!match && !this.orCondition) || (match && this.orCondition)) {
          break;
        }
      }
    } else if (typeof matchValue === 'string' && matchValue.startsWith('!')) {
      match = currentValue !== matchValue.substring(1);
    } else {
      match = currentValue === matchValue;
    }
    return match;
  }
}

export default Condition;
